import Service from "./Service";
import {isEmpty} from 'lodash';
const baseurl = '/api/tipo-historia';
export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    index(params = {}) {
        return Service.get(`${baseurl}`, {
            params : params
        });
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    cambiarEstado(id) {
        return Service.put(`${baseurl}/cambiarEstado/${id}`);
    },
    async list(search = '',pagination = {}) {
        let url = `${baseurl}/listar?`;

        url += search !== '' ? `s=${search}` : '';

        url += (!isEmpty(pagination))
            ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}`
            : '';

        return Service.get(url);
    },
}